"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _root = _interopRequireDefault(require("./style/root"));

var _shapeContainer = _interopRequireDefault(require("./style/shapeContainer"));

var _shapeWrapper = _interopRequireDefault(require("./style/shapeWrapper"));

var _shapeWrapperNext = _interopRequireDefault(require("./style/shapeWrapperNext"));

var _shape = _interopRequireDefault(require("./style/shape"));

var _constants = require("./constants");

var Skeleton = function Skeleton(_ref) {
  var theme = _ref.theme,
      duration = _ref.duration,
      animationName = _ref.animationName,
      shape = _ref.shape,
      children = _ref.children,
      direction = _ref.direction,
      infinite = _ref.infinite,
      style = _ref.style,
      delay = _ref.delay;
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  var column = direction === _constants.DIRECTION_COLUMN;
  var durationMS = typeof duration === 'number' ? "".concat(duration, "ms") : duration;

  var _useState = (0, _react.useState)(!delay || isNaN(delay)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  (0, _react.useEffect)(function () {
    var delayTimeout;

    if (delay && !isNaN(delay)) {
      delayTimeout = setTimeout(function () {
        return setVisible(true);
      }, delay);
    }

    return function () {
      return clearTimeout(delayTimeout);
    };
  }, [delay]);
  return visible ? _react["default"].createElement(_root["default"], {
    theme: memoTheme
  }, _react["default"].createElement(_shapeContainer["default"], null, _react["default"].createElement(_shapeWrapper["default"], {
    animationName: animationName,
    theme: memoTheme,
    column: column,
    duration: durationMS,
    infinite: infinite
  }, shape || _react["default"].createElement(_shape["default"], {
    theme: memoTheme,
    column: column
  })), _react["default"].createElement(_shapeWrapperNext["default"], {
    animationName: animationName,
    theme: memoTheme,
    column: column,
    duration: durationMS,
    infinite: infinite
  }, shape || _react["default"].createElement(_shape["default"], {
    theme: memoTheme,
    column: column
  }))), children) : null;
};

Skeleton.defaultProps = {
  infinite: true,
  duration: '3s',
  direction: _constants.DIRECTION_ROW
};
Skeleton.propTypes = {
  infinite: _propTypes["default"].bool,
  duration: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  direction: _propTypes["default"].oneOf([_constants.DIRECTION_ROW, _constants.DIRECTION_COLUMN]),
  animationName: _propTypes["default"].string,
  shape: _propTypes["default"].any,
  children: _propTypes["default"].any,
  delay: _propTypes["default"].number,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.elLightestHEX
     */
    background: _propTypes["default"].string,

    /**
     * @default linear-gradient(to right, ${palette.elLightestHEX}, ${palette.elLightHEX} 55%, ${palette.elLightestHEX})
     */
    shapeBackground: _propTypes["default"].string,

    /**
     * @default linear-gradient(to bottom, ${palette.elLightestHEX}, ${palette.elLightHEX} 55%, ${palette.elLightestHEX})
     */
    shapeBackgroundColumn: _propTypes["default"].string,

    /**
     * @default screen.availHeight + 'px'
     */
    shapeHeight: _propTypes["default"].string,

    /**
     * @default screen.availWidth + 'px'
     */
    shapeWidth: _propTypes["default"].string
  })
};
var _default = Skeleton;
exports["default"] = _default;